import {useState, useRef, useEffect} from 'react';
import { dynamicFilter } from './filtrationComponent';
import styles from './listView.module.scss';
import { API_ROOT, sendRequest } from '../../../supplementary_components/requests';
import { addNotification } from '../../../supplementary_components/store';


export function appendFiltrationParams(linkRoot, { lastId, batchSize, categoryLabel } = {}) {
    const params = [];
    if (categoryLabel) params.push(`category=${categoryLabel}`);
    if (lastId != null) params.push(`lastId=${lastId}`);
    if (batchSize != null) params.push(`batchSize=${batchSize}`);
    return params.length ? `${linkRoot}?${params.join('&')}` : linkRoot;
}

function getCategoryFromFiltrationLink(link) {
    const query = link.split('?')[1];
    if (!query) return null;
    return new URLSearchParams(query).get('category');
}

function applyFilter(dataset, searchValue, selectedFilter, filtrationData, setFilteredData, exactMatch){
    searchValue = searchValue.replace(selectedFilter.filtrationLbl, "").trim();
    if(searchValue.length === 0) {
        setFilteredData(null)
        return;
    };
    const newDataset = dynamicFilter(dataset, searchValue, [selectedFilter.valueLocation], true, selectedFilter.searchTermTransformer, exactMatch, selectedFilter.splittingChar, selectedFilter.conditionalCheck);
    // const updatedPayload = filtrationData.payloadGenerator([{"key":selectedFilter.searchKey, "pattern": searchValue}], newDataset)
    const payload = {"searchTermsAndPatterns": [{"key":selectedFilter.searchKey, "pattern": searchValue}]}
    const currentLastId = getCurrentLastId(dataset);    
    const link = appendFiltrationParams(filtrationData.filtrationLinkRoot, {
        lastId: currentLastId,
        categoryLabel: filtrationData.categoryLabel,
    });
    setFilteredData({
        nextBatchLink : link,
        nextBatchSize : 20,
        loadMore:(onFinish, link, batchSize)=>{
            sendRequest("POST", API_ROOT + link + (batchSize ? `&batchSize=${batchSize}` : ""), null, (res)=>{
                onFinish();
                if(res){
                    const lastId = getCurrentLastId(res);
                    setFilteredData(prev => {
                        const updatedArray = [...prev.dataset, ...res];
                        return {
                            dataset : updatedArray,
                            nextBatchLink : res.length >= batchSize ? updateNextBatchLink(link, lastId) : null,
                            nextBatchSize: batchSize * 2,
                            loadMore : res.length >= batchSize ? prev.loadMore : null
            
                        }
                    });
                }
            }, ()=>{
                onFinish();
                addNotification({message:`Something went wrong`, type:'alert'});
            }, payload)
        },
        dataset: newDataset
    });
}
export function getCurrentLastId(dataset){
    return dataset && dataset.length > 0 
                ? dataset.reduce((min, item) => item.id < min ? item.id : min, dataset[0].id) 
                : null;
}
export function updateNextBatchLink(currentLink, lastId){
    const linkRoot = currentLink.split('?')[0];
    const categoryLabel = getCategoryFromFiltrationLink(currentLink);
    return appendFiltrationParams(linkRoot, { lastId: lastId ?? undefined, categoryLabel });
}
export const QuickFiltrationComponent = ({filtrationData, dataset, setFilteredData}) => {
    const inputField = useRef(null);
    const [filtrationText, setFiltrationText] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [selectedSuggestions, setSelectedSuggestions] = useState(null);
    function getSelectedFilterInAny(searchTerm){
        if(searchTerm && searchTerm !== ""){
            if(searchTerm.includes(":")){
                for(const fieldData of filtrationData.searchByFieldNames){
                    if(fieldData.filtrationLbl && searchTerm.startsWith(fieldData.filtrationLbl)){
                        return fieldData;
                        // searchValue = searchValue.replace(fieldData.filtrationLbl, "").trim();
                    }
                }
            }
        }
        return null;
    }
    const selectedFilter = getSelectedFilterInAny(filtrationText);
    const choosingFromSuggestions = selectedFilter && selectedFilter.customSuggestions;
    
    useEffect(()=>{
        if(!selectedSuggestions){
            if(choosingFromSuggestions){
                setSelectedSuggestions([])
            }
        }else if(!choosingFromSuggestions){
            setSelectedSuggestions(null);
        }
        if(!filtrationText || filtrationText === ""){
            setFilteredData(null);
        }
        if(selectedFilter && selectedFilter.acceptSuggestionAsTerm && filtrationText.includes(':')){
            let arrayOfParts = filtrationText.split(":");
            if(arrayOfParts.length > 1){
                const desiredPart = arrayOfParts[1];
                selectedFilter.customSuggestions.forEach(suggestion => {
                    if(suggestion.toLowerCase() === desiredPart.trim().toLowerCase()){
                        applyFilter(dataset, suggestion.toLowerCase(), selectedFilter, filtrationData, setFilteredData, true);
                        setShowSuggestions(false);
                        
                        return;
                    }
                });
            }
        }
    // eslint-disable-next-line
    }, [filtrationText]);
    useEffect(()=>{
        if(selectedSuggestions && choosingFromSuggestions){
            applyFilter(dataset, filtrationText + selectedSuggestions.join(", "), selectedFilter, filtrationData, setFilteredData, true);
        }
    // eslint-disable-next-line
    }, [selectedSuggestions]);
    const setCategory = (e) => {
        e.stopPropagation();
        e.preventDefault();
        try {
            let filterOptionTag = e.target;
            if(filterOptionTag.className === "filterHint"){
                filterOptionTag = filterOptionTag.parentNode.childNodes[0];
            }else{
                while(filterOptionTag.tagName.toLowerCase() !== "span" && filterOptionTag.childNodes.length > 0){
                    filterOptionTag = filterOptionTag.childNodes[0];
                }
            }
            
            if(filterOptionTag.className.includes("filterOption")){
                if(choosingFromSuggestions){
                    if(selectedFilter.acceptSuggestionAsTerm){
                        setFiltrationText(prev => prev + filterOptionTag.innerText);
                    }else{
                        if(filterOptionTag.className.includes(styles.selectedOption)){
                            setSelectedSuggestions(prev => prev.filter(item => item !== filterOptionTag.innerText));
                        }else{
                            setSelectedSuggestions(prev => [...prev, filterOptionTag.innerText]);
                        }
                    }
                    
                    
                }else{
                    setFiltrationText(filterOptionTag.innerText + " ");
                }
                
            }
            
            inputField.current.focus()
            
        } catch (error) {
            
        }
    }
    
    return <div className={styles.filtrationComponent}>
        <input ref={inputField} placeholder={'Quick Filtration'} className={styles.filtrationInput} 
            value={choosingFromSuggestions && selectedSuggestions ? filtrationText + selectedSuggestions.join(", ") : filtrationText}
            onFocus={(e)=>{
                if(e.target.value === ""){
                    setShowSuggestions(true);
                }else{
                    if(choosingFromSuggestions && (!selectedFilter.acceptSuggestionAsTerm || (/:$/).test(filtrationText.trim()))){
                        setShowSuggestions(true);
                    }else{
                        setShowSuggestions(false);
                    }
                }
            }}
            onBlur={(e)=>{
                if(showSuggestions){
                    let selected = false;
                    try {
                        for (const child of e.target.nextSibling.childNodes){
                            if(child.matches(':hover')){
                                selected = true;
                                break;
                            }
                        }
                    } catch (error) {}
                    
                    if(!selected){
                        setShowSuggestions(false);
                    }
                }
                
            }}
            onChange={(e)=>{
                const searchTerm = e.target?.value;
                if(searchTerm && searchTerm !== ""){
                    
                    if(choosingFromSuggestions && !selectedFilter.acceptSuggestionAsTerm){
                        return;
                    }
                    setShowSuggestions(false);
                    if(selectedFilter){
                        applyFilter(dataset, searchTerm.trim(), selectedFilter, filtrationData, setFilteredData, false);
                    }else{
                        const trimmed = searchTerm.trim();
                        const newDataset = dynamicFilter(dataset, trimmed, filtrationData.searchByFieldNames, false);
                        const firstField = filtrationData.searchByFieldNames?.[0];
                        if (newDataset.length === 0 && firstField?.searchKey && trimmed.length > 0) {
                            const payload = { searchTermsAndPatterns: [{ key: firstField.searchKey, pattern: trimmed }] };
                            const link = appendFiltrationParams(filtrationData.filtrationLinkRoot, {
                                lastId: getCurrentLastId(dataset),
                                categoryLabel: filtrationData.categoryLabel,
                            });
                            setFilteredData({
                                dataset: newDataset,
                                nextBatchLink: link,
                                nextBatchSize: 20,
                                loadMore: (onFinish, linkArg, batchSize) => {
                                    sendRequest('POST', API_ROOT + linkArg + (batchSize ? `&batchSize=${batchSize}` : ''), null, (res) => {
                                        onFinish();
                                        if (res) {
                                            const lastId = getCurrentLastId(res);
                                            setFilteredData((prev) => {
                                                const updatedArray = [...prev.dataset, ...res];
                                                return {
                                                    dataset: updatedArray,
                                                    nextBatchLink: res.length >= batchSize ? updateNextBatchLink(linkArg, lastId) : null,
                                                    nextBatchSize: batchSize * 2,
                                                    loadMore: res.length >= batchSize ? prev.loadMore : null,
                                                };
                                            });
                                        }
                                    }, () => {
                                        onFinish();
                                        addNotification({ message: `Something went wrong`, type: 'alert' });
                                    }, payload);
                                },
                            });
                        } else {
                            setFilteredData({ dataset: newDataset });
                        }
                    }
                }else{
                    setShowSuggestions(true);
                }
                setFiltrationText(searchTerm || "")
            }}
        />
        
        {showSuggestions && (choosingFromSuggestions || !filtrationText || filtrationText === "") ?
        <div className={`${styles.suggestionsBox} non-selectable`}>
            {(choosingFromSuggestions ? selectedFilter.customSuggestions : filtrationData.searchByFieldNames).map((val, index)=>{
                if(choosingFromSuggestions)return <div key={index} onClick={setCategory}>
                    <span className={`filterOption ${selectedSuggestions && selectedSuggestions.includes(val) ? styles.selectedOption : ""}`} >{val} </span>
                </div>
                if(!val.filtrationLbl || val.notInInlineFilterMode)return null;
                return<div key={index} onClick={setCategory}><span className="filterOption">{val.filtrationLbl} </span> <div className="filterHint">{val.hint}</div></div>
            })} 
        </div>
        :null}
    </div>
}